module.exports = __webpack_public_path__ + "static/img/bg07.cfb6437.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bg07.png
// module id = 8N0J
// module chunks = 62